export function Search (): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
    >
      <path
        d='M9.27441 17.1367C13.6927 17.1367 17.2744 13.555 17.2744 9.13672C17.2744 4.71844 13.6927 1.13672 9.27441 1.13672C4.85614 1.13672 1.27441 4.71844 1.27441 9.13672C1.27441 13.555 4.85614 17.1367 9.27441 17.1367Z'
        stroke='#858585'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M19.2743 19.1371L14.9243 14.7871'
        stroke='#858585'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
